<template>
  <div class="inventory_home">
    <b-container fluid>
      <h1>Inventory</h1>
      <b-tabs>
        <b-tab v-for="location in warehouseLocations" :key="location" :title="location">
          <b-tabs class="mt-2">
            <b-tab title="Inventory Management">
              <InventoryManagement :location="location"></InventoryManagement>
            </b-tab>
            <b-tab title="Stock In">
              <InventoryStockIn :location="location"></InventoryStockIn>
            </b-tab>
            <b-tab title="Stock Out">
              <InventoryStockOut :location="location"></InventoryStockOut>
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import InventoryManagement from './InventoryManagement.vue'
import InventoryStockIn from './InventoryStockIn.vue'
import InventoryStockOut from './InventoryStockOut.vue'

export default {
  props: {
    user: Object,
  },
  data() {
    return {
      warehouseLocations: ["DAN", "TH"],
    }
  },
  components: {
    InventoryManagement,
    InventoryStockIn,
    InventoryStockOut,
  },
  methods: {

  }
}
</script>

<style>

</style>